export default __webpack_public_path__ + "static/musa-balthazaurus-scroll-8498b196065427818940e709e77308da.gif";